export default __webpack_public_path__ + "static/media/currentLocation.4b79efd2.svg";